module.exports = __webpack_public_path__ + "static/media/idd-logo-bw.9529acef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/idd-logo-bw.png
// module id = 513
// module chunks = 0